<template>
  <div class="benefit-text-container">
    <!-- Handle merged benefit texts -->
    <template v-if="merged && merged.length !== 0">
      <div v-for="(item, index) in merged" :key="index" class="benefit-group">
        <div class="text-content">
          <pre v-html="highlightRemaining(item.text)"></pre>
        </div>
        <ul v-if="item.notes && item.notes.length" class="notes-list">
          <li v-for="(note, noteIndex) in item.notes" :key="noteIndex" class="note-item">
            {{ (typeof note === 'object' ? note.message : note).toLowerCase() }}
          </li>
        </ul>
      </div>
    </template>
    <!-- Handle single benefit text -->
    <template v-else-if="text">
      <div class="benefit-group">
        <div class="text-content">
          <pre v-html="highlightRemaining(text)"></pre>
        </div>
        <ul v-if="notes && notes.length" class="notes-list">
          <li v-for="(note, index) in notes" :key="index" class="note-item">
            {{ (typeof note === 'object' ? note.message : note).toLowerCase() }}
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BenefitText',
  props: {
    merged: {
      type: Array,
      default: () => [],
    },
    text: {
      type: String,
      default: '',
    },
    notes: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    highlightRemaining(text) {
      if (!text) return '';
      return text.replace(/(Remaining|remaining)/g, '<strong>$1</strong>');
    },
  },
};
</script>

<style scoped>
.benefit-text-container {
  margin: 1.5rem 0;
}

.benefit-group {
  border-left: 3px solid #e0e0e0;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.benefit-group:hover {
  border-left-color: #7957d5;
}

.benefit-group:hover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(121, 87, 213, 0.05), transparent);
  pointer-events: none;
}

.benefit-group:last-child {
  margin-bottom: 0;
}

.text-content {
  margin-bottom: 0.25rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
}

.benefit-group:hover .text-content {
  transform: scale(1.02);
  transform-origin: left;
}

.text-content pre {
  background: transparent;
  padding: 0;
  margin: 0;
  font-size: 1.1rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  color: #363636;
  font-family: inherit;
  line-height: 1.5;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.notes-list {
  list-style: none;
  margin: 0 !important;
  padding: 0;
  padding-top: 0.25rem;
}

.note-item {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 0.4rem;
  padding-left: 1.25rem;
  position: relative;
  line-height: 1.4;
}

.note-item:before {
  content: '•';
  position: absolute;
  left: 0.5rem;
  color: #7957d5;
  font-weight: bold;
}

.note-item:last-child {
  margin-bottom: 0;
}
</style>
